import axios from 'axios'
import {AMBROSIA_URL} from "../../helpers/auth-header";

export default {

    /**
     * Make phone call to gofarma
     *
     *
     */
    PhoneCall() {
        window.location.href = "tel:+5218183532639" // TODO: Make this configurable from somewhere
    },

    /**
     *
     * @constructor
     */
    SetAppScrollLock({commit}, payload) {
        document.querySelector('body').classList.toggle('no-scroll', payload);
    },

    /**
     * Open whatsapp web in browser
     *
     * @param dispatch
     */
    OpenWhatsAppMessenger({dispatch}) {
        //Default is for web browsers
        let whatsAppLink = 'https://web.whatsapp.com/send?phone=5218117640845';
        //The only way safari allows to open the app is via protocol
        if (dispatch('isUserApple')) window.whatsAppLink = 'whatsapp://send?phone=+5218117640845';
        //Android in the other hand needs this call in order for it to work
        else if (dispatch('isUserAndroid')) window.whatsAppLink = 'https://api.whatsapp.com/send?phone=5218117640845';

        //window.location.href = whatsAppLink
        window.open(whatsAppLink)
    },

    /**
     * Fetches entities from the server that will be reused
     *
     * @param commit
     * @constructor
     */
    FetchEntities( { commit , dispatch } ){
        // -- Make sure all promises are completed, otherwise have the user try again
        axios.all([
            axios.get(`${AMBROSIA_URL}/order/shipping-products`),
            axios.get(`${AMBROSIA_URL}/global/entities?categories=com.gofarma.olimpo.entities.Category&marketingStrategies=com.gofarma.olimpo.entities.MarketingStrategy&neighborhoods=com.gofarma.olimpo.entities.Neighborhood&sorted=1`)
        ])
        .then( r => {
            // -- Each response from promise
            let shippingProductsResponse = r[0];
            let globalEntitiesResponse = r[1];

            // -- Assigning state
            commit( 'StateAssign', {
                categories: globalEntitiesResponse.data.data.categories,
                marketingStrategies: globalEntitiesResponse.data.data.marketingStrategies,
                neighborhoods: globalEntitiesResponse.data.data.neighborhoods,
                shippingProducts: shippingProductsResponse.data.data
            })

            // -- Post fetching requirements go here
            dispatch('FilterCategories')
        })
        .catch( ex => dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors }) )
    },

    /**
     * Sets order id in cookie
     *
     * @param state
     * @param orderId
     */
    SetOrderId({}, orderId) {
        if (orderId) {
            localStorage.setItem('orderId', orderId);
        } else {
            localStorage.removeItem('orderId');
        }
    },

    /**
     * Sets the current state of an order and updates order totals
     *
     * @param commit
     * @param order
     * @param state
     * @param dispatch
     *
     * @constructor
     */
    SetOrder({commit, state, dispatch}, order) {
        let _total = 0;
        let _discounts = 0;
        let _advances = 0;
        let _paymentMethods = 0;
        let shippingProfileTotal = 0;
        for (let i = 0; i < order.transactionMatrix.length; i++) {
            let t = order.transactionMatrix[i];
            if( !t.isValid ) continue;
            if ( t.type === 'PRODUCT_ENTRY' ) _total += t.delta * ( t.amountTax + t.amount );
            if ( t.type === 'SHIPPING' ){
                _total += t.delta * ( t.amountTax + t.amount );
                shippingProfileTotal += t.delta * ( t.amountTax + t.amount );
            }
            if ( t.type === 'DISCOUNT' || t.type === 'COUPON') {
                _total += t.delta * ( t.amountTax + t.amount );
                _discounts += t.delta * ( t.amountTax + t.amount );
            }
            if ( t.type === 'PAYMENT_METHOD' ) _paymentMethods += t.delta * t.amount;
            if ( t.type === 'PAYMENT_METHOD' ) _advances += t.delta * t.advance;
        }

        let nonCashPaymentMethods = order.transactionMatrix.filter( t => t.isValid && t.type === 'PAYMENT_METHOD' && t.paymentMethodType !== 'CASH' ).reduce( ( acc , value ) => acc + value.amount , 0 );
        let cashPaymentMethods = order.transactionMatrix.filter( t => t.isValid && t.type === 'PAYMENT_METHOD' && t.paymentMethodType === 'CASH' ).reduce( ( acc , value ) => acc + value.amount , 0 );
        let paymentMethodEntries = order.transactionMatrix.filter( t => t.isValid && t.type === 'PAYMENT_METHOD' );
        let productEntries = order.transactionMatrix.filter( t => t.isValid ).filter( t => t.type === 'PRODUCT_ENTRY' || t.type === 'DISCOUNT' || t.type === 'COUPON' || t.type === 'SHIPPING' );
        let couponEntries = order.discountEntries.filter(t => t.type === 'COUPON');

        // -- Calculating pending to express
        let pendingToExpress = _total - ( cashPaymentMethods + nonCashPaymentMethods )

        // -- Calculating change
        let change;

        if( nonCashPaymentMethods > _total && cashPaymentMethods > 0 ){
            change = cashPaymentMethods;
        }else{
            change = Math.max( cashPaymentMethods - ( _total - nonCashPaymentMethods ) , 0 );
        }

        commit('StateAssign', {
            order,
            paymentMethodEntries,
            couponEntries,
            productEntries,
            orderTotals: {
                total: _total,
                discounts: _discounts,
                advances: _advances,
                change: change,
                shippingProfileTotal: shippingProfileTotal,
                pendingToExpress: pendingToExpress,
                paymentMethods: _paymentMethods
            }
        });

        dispatch('SetOrderId', order.id)
    },
    /**
     * Adds a product via quantity
     * @param commit
     * @param dispatch
     * @param state
     * @param e
     *
     * @constructor
     */
    AddRawProduct({commit, dispatch, state}, e) {
        dispatch('ShowLoadingToast', {'text': 'Actualizando carrito'});
        let postData = {
            productId: e.product.id,
            quantity: e.quantity
        };
        axios.post(`${AMBROSIA_URL}/order/${state.order.id}/add-product`, postData)
        .then(r => {
            dispatch('SetOrder', r.data.data);
        })
        .then(r => {
            dispatch('CloseToast');
            dispatch('ShowToast', {'icon': 'success', 'title': 'Se actualizo el carrito'})
        })
        .catch(ex => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors })
        })
    },

    /**
     * Fetches current order by ID
     * @param commit
     * @param dispatch
     * @param state
     * @param e
     *
     * @constructor
     */
    FetchOrder({state, dispatch}) {
        // -- Check to see if local storage has a set OrderID. If so, use it instead
        let orderId = localStorage.getItem('orderId');

        // -- If no order set, then use the generated ID to create a new order
        if ( !orderId ) orderId = state.order.id;

        axios.get(`${AMBROSIA_URL}/order/${orderId}`)
        .then(r => {
            if (r.data.data) {
                dispatch('SetOrder', r.data.data);
                dispatch('GetShippingProfileForAddress', r.data.data.shippingAddress)
            }
        })
        .catch(ex => {
            console.log( ex );
            dispatch('ShowToast', {'icon': 'error', 'title': 'Ocurrio un error al obtener tu orden actual'})
        })
    },
}